import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b34c3e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bold" }, "Ameaças por país"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 align-self-center" }, "clique para filtrar")
], -1))
const _hoisted_3 = { class: "card-body pt-0 overflow-hidden" }
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 1,
  class: "text-muted fs-7 py-10 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("div", {
        id: _ctx.mapId,
        class: "trf-worldmap"
      }, null, 8, _hoisted_4), [
        [_vShow, !_ctx.failed]
      ]),
      (_ctx.failed)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.series[0].data.length)
              ? (_openBlock(), _createBlock(_component_apexchart, {
                  key: 0,
                  type: "bar",
                  height: "360",
                  options: _ctx.options,
                  series: _ctx.series
                }, null, 8, ["options", "series"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, "Sem dados de países na janela."))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}